import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, isRef as _isRef, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("搜索 ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("重置 ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("创建盘点任务")
const _hoisted_4 = { class: "d-flex d-flex-row-reverse" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", null, " 创建盘点任务 ", -1)
const _hoisted_6 = { class: "d-flex justify-content--center pt-20 pb-20" }
const _hoisted_7 = { class: "dialog-footer" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("取 消")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("确 定 ")

import {onBeforeMount, reactive, ref} from "vue";
import Api from "@/http/modules";
import {ElMessage} from "element-plus";
import tbMix from "@/global_mixin/tableMixin";
import {task_status_init} from "@/views/ViewsComponents/officeAssets/OfficeAssetUtils";


export default /*#__PURE__*/_defineComponent({
  emits: ['showDetail'],
  setup(__props, { emit }) {

const {
  //创建
  "POST/office/asset/task": createTaskApi,
  "POST/office/asset/task/list": taskListApi,
  "POST/office/asset/task/delete": deleteTaskApi,
} = Api

const {
  MI_tableData, fetchData, page, size, MI_total, MI_pageChange,
  MI_sizeChange, MI_identify, MI_params, MI_modifyForm, MI_height
} = new tbMix(taskListApi)
const searchEle=ref()
const searchObj = reactive<{
  taskNo: string | null
}>({
  taskNo: null
})
const inventoryInfo = reactive<{
  loading: boolean
}>({
  loading: false
})
const search = () => {
  page.value = 1
  fetchData(searchObj)
}
onBeforeMount(() => {
  search()
})
const taskDialog = reactive<{
  loading: boolean,
  isShow: boolean
}>({
  loading: false,
  isShow: false
})
const createTaskParams = reactive<{
  name: string | null,
  start: string | null,
}>({
  name: null,
  start: null
})
const createTaskFormRef = ref()
const showTaskDialog = () => {
  taskDialog.isShow = true
  setTimeout(() => {
    createTaskFormRef.value.resetFields()
  }, 10)
}
const createTask = () => {
  createTaskFormRef.value.validate((valid: boolean) => {
    if (valid) {
      taskDialog.loading = true
      createTaskApi(createTaskParams).then((r: any) => {
        search()
        taskDialog.loading = false
        ElMessage.success("创建盘点任务成功")
        taskDialog.isShow = false

      }).catch(() => {
        taskDialog.loading = false
      })
    }
  })

}
const operateTask = (task: any) => {
  if (task.status === task_status_init) {
    // 删除
    deleteTaskApi({no: task.no}, {contentType: "formData"}).then((r: any) => {
      ElMessage.success("删除成功")
      search()
    })
  } else {
    //详情
    emit("showDetail", task)
  }


}


return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_collapse, { class: "mb-10 inventory-collapse" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_collapse_item, {
          title: "搜索",
          name: "1"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form, {
              class: "searchContent searchBg",
              model: _unref(searchObj),
              "label-width": "90px",
              inline: true,
              ref_key: "searchEle",
              ref: searchEle,
              "label-position": "right"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: "盘点单号",
                  prop: "method",
                  class: "flex-1"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _unref(searchObj).taskNo,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(searchObj).taskNo) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      loading: _unref(inventoryInfo).loading,
                      disabled: _unref(inventoryInfo).loading,
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (search()))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_1
                      ]),
                      _: 1
                    }, 8, ["loading", "disabled"]),
                    _createVNode(_component_el_button, {
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(searchObj).taskNo=null))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_2
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_button, {
      type: "primary",
      class: "mt-5",
      onClick: showTaskDialog
    }, {
      default: _withCtx(() => [
        _hoisted_3
      ]),
      _: 1
    }),
    _createElementVNode("div", null, [
      _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        ref: "assetInventoryTbEle",
        border: "",
        class: "mt-15",
        data: _unref(MI_tableData),
        "row-key": "id",
        "max-height": _unref(MI_height) - 100 + 'px'
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            label: "盘点单号",
            prop: "no",
            "min-width": "200"
          }),
          _createVNode(_component_el_table_column, {
            label: "任务名称",
            prop: "name",
            "min-width": "100",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "开始时间",
            prop: "startDesc",
            "min-width": "160"
          }),
          _createVNode(_component_el_table_column, {
            label: "盘点状态",
            prop: "statusDesc",
            "min-width": "100"
          }),
          _createVNode(_component_el_table_column, {
            label: "所有数量",
            prop: "total",
            "min-width": "100"
          }),
          _createVNode(_component_el_table_column, {
            label: "未确认数量",
            prop: "unConfirmedCount",
            "min-width": "120"
          }),
          _createVNode(_component_el_table_column, {
            label: "创建人",
            prop: "userName",
            "min-width": "160"
          }),
          _createVNode(_component_el_table_column, {
            label: "操作",
            fixed: "right",
            width: "120"
          }, {
            default: _withCtx(({ row }) => [
              _createVNode(_component_el_space, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_link, {
                    type: row.status===_unref(task_status_init)?'danger':'info',
                    onClick: ($event: any) => (operateTask(row))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(row.status === _unref(task_status_init) ? "删除" : "详情"), 1)
                    ]),
                    _: 2
                  }, 1032, ["type", "onClick"])
                ]),
                _: 2
              }, 1024)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data", "max-height"])), [
        [_directive_loading, _unref(MI_identify)]
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_el_pagination, {
          disabled: _unref(MI_identify),
          background: "",
          small: "",
          total: _unref(MI_total),
          currentPage: _unref(page),
          "onUpdate:currentPage": _cache[3] || (_cache[3] = ($event: any) => (_isRef(page) ? (page).value = $event : null)),
          "page-size": _unref(size),
          "onUpdate:page-size": _cache[4] || (_cache[4] = ($event: any) => (_isRef(size) ? (size).value = $event : null)),
          class: "mt-10",
          "page-sizes": [10, 30, 50, 100, 300, 1000],
          layout: "sizes, prev, pager, next, total, jumper",
          onCurrentChange: _unref(MI_pageChange),
          onSizeChange: _unref(MI_sizeChange)
        }, null, 8, ["disabled", "total", "currentPage", "page-size", "onCurrentChange", "onSizeChange"])
      ])
    ]),
    _createVNode(_component_el_dialog, {
      class: "createTaskDialog",
      modelValue: _unref(taskDialog).isShow,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(taskDialog).isShow) = $event)),
      draggable: "",
      width: "600px"
    }, {
      header: _withCtx(() => [
        _hoisted_5
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_el_button, {
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_unref(taskDialog).isShow=false))
          }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: createTask,
            loading: _unref(taskDialog).loading,
            disabled: _unref(taskDialog).loading
          }, {
            default: _withCtx(() => [
              _hoisted_9
            ]),
            _: 1
          }, 8, ["loading", "disabled"])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_el_form, {
            class: "createTaskForm",
            model: _unref(createTaskParams),
            "label-width": "90px",
            style: {"width":"400px"},
            ref_key: "createTaskFormRef",
            ref: createTaskFormRef
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                label: "任务名称",
                prop: "name",
                required: "",
                rules: [{required:true,message:'请输入任务名称'}]
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _unref(createTaskParams).name,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(createTaskParams).name) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "开始时间",
                prop: "start",
                class: "mt-10",
                required: "",
                rules: [{required:true,message:'请选择开始时间'}]
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_date_picker, {
                    style: {"width":"100%"},
                    modelValue: _unref(createTaskParams).start,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(createTaskParams).start) = $event)),
                    type: "datetime",
                    "value-format": "YYYY-MM-DDTHH:mm:00",
                    format: "YYYY-MM-DD HH:mm"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})